module.exports = __webpack_public_path__ + "img/main_img_1.256b022a.jpg";